import { connect } from 'react-redux'

import LoginWithoutPassword from './LoginWithoutPassword'
import { clearAuthStatuses } from 'store/entities/identity/actions'
import { modal } from 'store/entities/modal/actions'
import { isTokenSendToPhone, isTokenSendToEmail } from 'store/entities/identity/selectors'
import { getUILoginPhoneError } from 'store/entities/ui/selectors'
import { getQueries } from 'store/entities/localSettings/selectors'
import { getOrganizationSettingsByDomainCountriesCodes } from 'store/entities/organizationSettings/selectors'

const mapStateToProps = state => ({
  isTokenSendToPhone: isTokenSendToPhone(state),
  isTokenSendToEmail: isTokenSendToEmail(state),
  loginPhoneError: getUILoginPhoneError(state),
  phone: getQueries(state).get('phone'),
  countriesCodes: getOrganizationSettingsByDomainCountriesCodes(state),
})

const mapDispatchToProps = {
  showModal: modal.show,
  clearAuthStatuses,
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginWithoutPassword)
